(() => {
  const SELECTOR = '[data-wholesale-packaging-choice]';
  const STATUS = '[data-wholesale-packaging-status]';

  const PACKAGING_VARIANTS = {
    '3x4': 51182297383155,
    '3x7': 51182268842227
  };

  let syncingPackaging = false;

  function setStatus(message) {
    document.querySelectorAll(STATUS).forEach((element) => {
      element.textContent = message;
    });
  }

  function syncSelectors(value) {
    document.querySelectorAll(SELECTOR).forEach((select) => {
      select.value = value;
    });
  }

  function getPackagingRequirementsFromDocument() {
    const requirements = {};

    document
      .querySelectorAll(
        '[data-wholesale-packaging-eligible="true"]'
      )
      .forEach((row) => {
        const size = row.dataset.wholesalePackagingSize;
        const quantity = parseInt(
          row.dataset.wholesalePackagingQuantity,
          10
        );

        if (!size || !quantity || quantity <= 0) {
          return;
        }

        requirements[size] =
          (requirements[size] || 0) + quantity;
      });

    return requirements;
  }

  function getPackagingRequirementsFromSection(sectionHtml) {
    const requirements = {};

    if (!sectionHtml) {
      return requirements;
    }

    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(
      sectionHtml,
      'text/html'
    );

    parsedDocument
      .querySelectorAll(
        '[data-wholesale-packaging-eligible="true"]'
      )
      .forEach((row) => {
        const size = row.dataset.wholesalePackagingSize;
        const quantity = parseInt(
          row.dataset.wholesalePackagingQuantity,
          10
        );

        if (!size || !quantity || quantity <= 0) {
          return;
        }

        requirements[size] =
          (requirements[size] || 0) + quantity;
      });

    return requirements;
  }

 
  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(
      'Could not read the current cart.'
    );
  }

  return response.json();
}

async function removeWholesalePackagingForRegularCustomer() {
  console.log(
    '[Wholesale packaging] Cleanup function started.'
  );

  const wholesaleCustomer =
    document.querySelector('[data-wholesale-customer]')?.dataset.wholesaleCustomer === 'true';

  if (wholesaleCustomer) {
    return;
  }

  const cart = await getCart();

  const packagingLines = cart.items.filter(
    (item) =>
      item.properties?._WholesalePackaging === 'true'
  );

  if (packagingLines.length === 0) {
    return;
  }

  console.log(
    '[Wholesale packaging] Regular customer detected. Removing leftover packaging lines:',
    packagingLines
  );

  for (const item of packagingLines) {
    await changeCartLine(item.key, 0);
  }

  console.log(
    '[Wholesale packaging] Leftover wholesale packaging removed.'
  );
}
async function syncWholesalePackagingOnPageLoad() {
  console.log(
    '[Wholesale packaging] Page-load sync started.'
  );

  const wholesaleCustomer =
    document.querySelector('[data-wholesale-customer]')?.dataset.wholesaleCustomer === 'true';

  if (!wholesaleCustomer) {
    return;
  }

  const cart = await getCart();

  const value =
    cart.attributes?.wholesale_packaging;

  if (
    !['regular', 'hanging', 'none'].includes(value)
  ) {
    console.log(
      '[Wholesale packaging] No saved packaging preference. Nothing to sync.'
    );
    return;
  }

  const requirements =
    getPackagingRequirementsFromDocument();

  console.log(
    '[Wholesale packaging] Restoring saved preference:',
    value,
    requirements
  );

  syncingPackaging = true;

  try {
    await syncPackaging(
      value,
      requirements
    );

    syncSelectors(value);

    console.log(
      '[Wholesale packaging] Page-load packaging sync complete.'
    );
  } catch (error) {
    console.error(
      '[Wholesale packaging] Page-load packaging sync failed:',
      error
    );
  } finally {
    syncingPackaging = false;
  }
}

async function refreshWholesaleCartDisplay() {
  console.log(
    '[Wholesale packaging] Refreshing cart display after customer login.'
  );

  const cartComponents =
    document.querySelectorAll('cart-items-component');

  if (cartComponents.length === 0) {
    console.log(
      '[Wholesale packaging] No cart components found to refresh.'
    );
    return;
  }

  for (const component of cartComponents) {
    const sectionId =
      component.dataset.sectionId;

    if (!sectionId) {
      continue;
    }

    try {
      const url =
        `${window.location.pathname}?section_id=${sectionId}&_wholesale_refresh=${Date.now()}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(
          `Section refresh failed: ${response.status}`
        );
      }

      const html = await response.text();

      const newSection =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );

      const newComponent =
        newSection.querySelector(
          `cart-items-component[data-section-id="${sectionId}"]`
        );

      if (!newComponent) {
        console.warn(
          '[Wholesale packaging] Could not find refreshed cart component for section:',
          sectionId
        );
        continue;
      }

      component.replaceWith(newComponent);

      console.log(
        '[Wholesale packaging] Cart display refreshed:',
        sectionId
      );
    } catch (error) {
      console.error(
        '[Wholesale packaging] Could not refresh cart section:',
        sectionId,
        error
      );
    }
  }
}

  async function addPackaging(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
            properties: {
              _WholesalePackaging: 'true'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const errorText = await response.text();

      throw new Error(
        `Could not add packaging: ${errorText}`
      );
    }

    return response.json();
  }

  async function changeCartLine(lineKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    });

    if (!response.ok) {
      const errorText = await response.text();

      throw new Error(
        `Could not update packaging: ${errorText}`
      );
    }

    return response.json();
  }

  async function updateCartAttribute(value) {
    const baseUrl =
      window.FoxTheme?.routes?.cart_update_url;

    if (!baseUrl) {
      throw new Error(
        'Could not find Shopify’s cart update route.'
      );
    }

    const updateUrl = baseUrl.endsWith('.js')
      ? baseUrl
      : `${baseUrl.replace(/\/$/, '')}.js`;

    const response = await fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          wholesale_packaging: value
        }
      })
    });

    if (!response.ok) {
      const errorText = await response.text();

      throw new Error(
        `Shopify could not save the packaging preference: ${errorText}`
      );
    }

    return response.json();
  }

  async function syncPackaging(
    value,
    requirements
  ) {
    if (value === 'none') {
      requirements = {};
    }

    console.log(
      '[Wholesale packaging] Requirements:',
      requirements
    );

    const cart = await getCart();

    const packagingLines = {};

    cart.items.forEach((item) => {
      for (const [size, variantId] of Object.entries(
        PACKAGING_VARIANTS
      )) {
        if (item.variant_id === variantId) {
          packagingLines[size] = item;
        }
      }
    });

    for (const [size, variantId] of Object.entries(
      PACKAGING_VARIANTS
    )) {
      const requiredQuantity =
        requirements[size] || 0;

      const existingLine =
        packagingLines[size];

      if (requiredQuantity > 0) {
        if (existingLine) {
          if (
            existingLine.quantity !==
            requiredQuantity
          ) {
            await changeCartLine(
              existingLine.key,
              requiredQuantity
            );
          }
        } else {
          await addPackaging(
            variantId,
            requiredQuantity
          );
        }
      } else if (existingLine) {
        await changeCartLine(
          existingLine.key,
          0
        );
      }
    }

    await updateCartAttribute(value);
  }

async function handleCartUpdate(event) {
  console.log('🔵 WHOLESALE HANDLER FIRED', event.detail);

  if (syncingPackaging) {
    return;
  }

  const data = event.detail?.data;

  if (!data) {
    return;
  }

  let select = document.querySelector(SELECTOR);
  let value = select?.value;

  /*
   * If the selector isn't currently in the DOM,
   * use the saved Shopify cart attribute instead.
   */
  if (!value) {
    try {
      const cart = await getCart();
      value = cart.attributes?.wholesale_packaging;
    } catch (error) {
      console.error(
        '[Wholesale packaging] Could not read packaging preference:',
        error
      );
      return;
    }
  }

  if (
    !['regular', 'hanging', 'none'].includes(value)
  ) {
    return;
  }

  let requirements = {};

  /*
   * Normal cart quantity/removal updates provide
   * the main cart section directly.
   */
  const mainSection =
    data.sections?.[
      'template--23107681124595__main'
    ];

  if (mainSection) {
    requirements =
      getPackagingRequirementsFromSection(
        mainSection
      );
  }

  /*
   * When the first product is added to an empty cart,
   * Bunie sends only the cart-drawer section.
   *
   * Fetch the main cart section ourselves so we can
   * read its wholesale packaging metadata.
   */
else if (
  data.source === 'product-form-component' ||
  data.source === 'cart-items-component'
) {    
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}?sections=template--23107681124595__main`,
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'Could not fetch the updated cart section.'
        );
      }

      const sections = await response.json();

      const freshMainSection =
        sections[
          'template--23107681124595__main'
        ];

      if (!freshMainSection) {
        console.error(
          '[Wholesale packaging] Main cart section was not returned.'
        );
        return;
      }

      requirements =
        getPackagingRequirementsFromSection(
          freshMainSection
        );
    } catch (error) {
      console.error(
        '[Wholesale packaging] Could not read fresh cart after product add:',
        error
      );
      return;
    }
  } else {
    return;
  }

  console.log(
    '[Wholesale packaging] Fresh cart requirements:',
    requirements
  );

  syncingPackaging = true;

  try {
    await syncPackaging(
      value,
      requirements
    );

    console.log(
      '[Wholesale packaging] Quantity sync complete.'
    );
  } catch (error) {
    console.error(
      '[Wholesale packaging] Quantity sync failed:',
      error
    );
  } finally {
    syncingPackaging = false;
  }
}

  document.addEventListener(
    'cart:update',
    handleCartUpdate
  );

  document.addEventListener(
    'change',
    async (event) => {
      const select =
        event.target.closest(SELECTOR);

      if (!select) {
        return;
      }

      const value = select.value;

      if (
        !['regular', 'hanging', 'none'].includes(value)
      ) {
        setStatus(
          'Please choose a packaging option.'
        );
        return;
      }

      document
        .querySelectorAll(SELECTOR)
        .forEach((element) => {
          element.disabled = true;
        });

      setStatus(
        'Saving your packaging preference…'
      );

      try {
        syncingPackaging = true;

        /*
         * For a packaging selection change, we intentionally
         * read the current sticker quantities from the DOM.
         *
         * When value is "none", syncPackaging() will remove
         * the packaging lines.
         */
        const requirements =
          getPackagingRequirementsFromDocument();

        await syncPackaging(
          value,
          requirements
        );

        syncSelectors(value);

        setStatus(
          'Packaging preference saved.'
        );

        console.log(
          '[Wholesale packaging] Packaging selection saved.'
        );
      } catch (error) {
        console.error(
          '[Wholesale packaging]',
          error
        );

        setStatus(
          'Sorry, your packaging preference could not be saved. Please try again.'
        );
      } finally {
        syncingPackaging = false;

        document
          .querySelectorAll(SELECTOR)
          .forEach((element) => {
            element.disabled = false;
          });
      }
    }
  );

removeWholesalePackagingForRegularCustomer()
  .then(() => {
    return syncWholesalePackagingOnPageLoad();
  })
  .then(() => {
    return refreshWholesaleCartDisplay();
  })
  .catch(
    (error) => {
      console.error(
        '[Wholesale packaging] Could not complete page-load cleanup/sync:',
        error
      );
    }
  );

})();